import { supabase } from '../supabase';

const TABLE_NAME = 'admin_page_images';
const BUCKET_NAME = 'website-images';

export async function getPageImages(pageKey) {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('images')
    .eq('page_key', pageKey)
    .maybeSingle();

  if (error) {
    throw error;
  }

  return data?.images || null;
}

export async function upsertPageImages(pageKey, images) {
  const payload = {
    page_key: pageKey,
    images,
    updated_at: new Date().toISOString()
  };

  const { error } = await supabase.from(TABLE_NAME).upsert(payload, {
    onConflict: 'page_key'
  });

  if (error) {
    throw error;
  }
}

export async function deletePageImages(pageKey) {
  const { error } = await supabase.from(TABLE_NAME).delete().eq('page_key', pageKey);
  if (error) {
    throw error;
  }
}

export async function uploadPageImage({ file, pageKey, imageKey }) {
  const extension = file.name.split('.').pop() || 'png';
  const safeImageKey = imageKey.replace(/\s+/g, '-').toLowerCase();
  const filePath = `${pageKey}/${safeImageKey}-${Date.now()}.${extension}`;

  const { error: uploadError } = await supabase.storage
    .from(BUCKET_NAME)
    .upload(filePath, file, {
      upsert: true,
      cacheControl: '3600'
    });

  if (uploadError) {
    throw uploadError;
  }

  const { data } = supabase.storage.from(BUCKET_NAME).getPublicUrl(filePath);
  return data.publicUrl;
}
